module.exports = __webpack_public_path__ + "static/media/Christine Lee.edef1903.png";